import { useMemo } from 'react';

import { useWatch } from 'react-hook-form';

import { RichOption } from '@liscio/api';


import { CreateAccountFormValues } from './createAccountValidationSchema';
import { getCreateAccountFormSectionVisibility } from './getCreateAccountFormSectionVisibility';
import { useHomeData, useProfileData } from 'fetch-utils/users/user-hooks';

type HomeSessionData = {
  firm_type?: string;
  pref_type_options?: {
    individual_entity_type?: RichOption[];
  };
};

export function useCreateAccountFormVisibility() {
  const { data: homeResponse } = useHomeData();
  const { isFirmAdmin } = useProfileData();
  const entityType = useWatch<CreateAccountFormValues, 'entity_type'>({
    name: 'entity_type',
  });

  const sessionData = homeResponse?.data as HomeSessionData | undefined;
  const firmType = sessionData?.firm_type;

  const visibility = useMemo(
    () => {
      const individualEntityTypes =
        sessionData?.pref_type_options?.individual_entity_type ?? [];

      return (
      getCreateAccountFormSectionVisibility({
        entityType,
        individualEntityTypes,
        firmType,
      })
      );
    },
    [entityType, firmType, sessionData?.pref_type_options?.individual_entity_type]
  );

  return {
    ...visibility,
    isFirmAdmin,
  };
}
